import {
    Component,
    inject,
    input,
    OnInit,
    signal,
    ChangeDetectionStrategy,
} from '@angular/core'
import { RouterLink, RouterLinkActive } from '@angular/router'
import { AuthStateService } from '@baboor/baboor-auth'
import { AppDetailsService } from '@baboor/common-services'
import { TooltipModule } from '@openng/optimus-ui/tooltip'
import { desktopNavItems, ClientNavItem } from '../../../client-navigation.data'
import { NavigationItem } from '../sidebar-default/sidebar.model'

@Component({
    selector: 'app-sidebar-client',
    imports: [RouterLink, RouterLinkActive, TooltipModule],
    templateUrl: './sidebar-client.component.html',
    styleUrl: './sidebar-client.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [AppDetailsService],
})
export class SidebarClientComponent implements OnInit {
    authStateService = inject(AuthStateService)
    private appDetailsService = inject(AppDetailsService)
    version = signal<string>('')
    isCollapsed = input(false)

    clientNavigationItems: NavigationItem[] = desktopNavItems().map(
        (item: ClientNavItem) => ({
            label: item.label,
            icon: item.icon,
            routerLink: item.routerLink,
        }),
    )
    isClient = signal(false)
    groupType = signal<string | null>(null)

    async ngOnInit() {
        const appVersion = await (
            await this.appDetailsService.getAppDetails()
        ).version
        this.version.set(appVersion)

        this.groupType.set(this.authStateService.getGroupType() ?? null)
        this.isClient.set(this.groupType() === 'client')
    }
}
